var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgRefreshLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10952_34175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.463 4.93301C7.27756 3.36067 9.59899 2.49666 12 2.50001C17.523 2.50001 22 6.97701 22 12.5C22 14.636 21.33 16.616 20.19 18.24L17 12.5H20C20.0001 10.9316 19.5392 9.39781 18.6747 8.08927C17.8101 6.78072 16.5799 5.75517 15.1372 5.14013C13.6944 4.5251 12.1027 4.34771 10.56 4.63003C9.0172 4.91234 7.59145 5.64191 6.46 6.72801L5.463 4.93301ZM18.537 20.067C16.7224 21.6393 14.401 22.5034 12 22.5C6.477 22.5 2 18.023 2 12.5C2 10.364 2.67 8.38401 3.81 6.76001L7 12.5H4C3.99987 14.0684 4.46075 15.6022 5.32534 16.9108C6.18992 18.2193 7.42007 19.2449 8.86282 19.8599C10.3056 20.4749 11.8973 20.6523 13.44 20.37C14.9828 20.0877 16.4085 19.3581 17.54 18.272L18.537 20.067Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10952_34175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.5)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh-line.2245b826aec14c6d4498f9479a86bb1e.svg";